import { IGetOrdemCompraCentroCustoDropDownUseCase } from "../../../presentation/useCases/read/get_ordem_compra_centro_custo_drop_down_use_case";
import { OrdemCompraCentroCustoDropDown } from "../../models/ordem_compra_centro_custo_dropdown";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraCentroCustoDropDownUseCase
 */

export class GetOrdemCompraCentroCustoDropDownUseCase implements IGetOrdemCompraCentroCustoDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraCentroCustoDropDown(
    idOrdemCompra: number | undefined,
  ): Promise<OrdemCompraCentroCustoDropDown[]> {
    return await this.repository.getOrdemCompraCentroCustoDropDown(
      idOrdemCompra,
    );
  }
}
